// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunk." + {"561": "871c479a6fe91cf5","757": "59d3c454041c5e87",}[chunkId] + ".js"
}